import User from "../types/user";

export enum UserRoles {
  GlobalAdmin = 1,
  DetectorAdmin,
  DetectorUser,
  GmdAdmin,
  GmdUser,
  ResponderAdmin,
  ResponderUser,
  InvestigatorAdmin,
  InvestigatorAudit,
  InvestigatorManager,
  InvestigatorSpecialist,
  InvestigatorOfficer,
  AnyAdmin,
  AnyDetector,
  AnyGmd,
  AnyResponder,
  AnyInvestigator,
}

const checkRole = (
  user: User,
  role: UserRoles,
  ownerAllowed?: boolean
): boolean => {
  const adminRoles: UserRoles[] = [
    UserRoles.GlobalAdmin,
    UserRoles.DetectorAdmin,
    UserRoles.GmdAdmin,
    UserRoles.ResponderAdmin,
    UserRoles.InvestigatorAdmin,
  ];

  const detectorRoles: UserRoles[] = [
    UserRoles.GlobalAdmin,
    UserRoles.DetectorAdmin,
    UserRoles.DetectorUser,
  ];

  const gmdRoles: UserRoles[] = [
    UserRoles.GlobalAdmin,
    UserRoles.GmdAdmin,
    UserRoles.GmdUser,
  ];

  const responderRoles: UserRoles[] = [
    UserRoles.GlobalAdmin,
    UserRoles.ResponderAdmin,
    UserRoles.ResponderUser,
  ];

  const investigatorRoles: UserRoles[] = [
    UserRoles.GlobalAdmin,
    UserRoles.InvestigatorAdmin,
    UserRoles.InvestigatorAudit,
    UserRoles.InvestigatorManager,
    UserRoles.InvestigatorSpecialist,
    UserRoles.InvestigatorOfficer,
  ];

  if (
    !user ||
    ((user.roles === undefined || user.roles.length < 1) &&
      !ownerAllowed &&
      !user.companyOwner)
  )
    return false;
  if (ownerAllowed && user.companyOwner) return true;
  if (role === UserRoles.AnyAdmin)
    return !!user?.roles.find((x) => adminRoles.includes(x.id));
  if (role === UserRoles.AnyDetector)
    return !!user?.roles.find((x) => detectorRoles.includes(x.id));
  if (role === UserRoles.AnyGmd)
    return !!user?.roles.find((x) => gmdRoles.includes(x.id));
  if (role === UserRoles.AnyResponder)
    return !!user?.roles.find((x) => responderRoles.includes(x.id));
  if (role === UserRoles.AnyInvestigator)
    return !!user?.roles.find((x) => investigatorRoles.includes(x.id));
  return !!user?.roles?.find((r) => r?.id === role);
};

export default checkRole;
